module.exports = __webpack_public_path__ + "img/组合40.0b182a5e.png";